import { Link } from 'react-router-dom';

export default function ServicesSection() {
  const services = [
    {
      title: 'Bounce House Rentals',
      description: 'Premium inflatable bounce houses and slides for all ages. Clean, safe, and professionally maintained equipment delivered on time.',
      icon: 'ri-home-smile-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png',
      link: '/bounce-house-rentals'
    },
    {
      title: 'Interactive Group Activities',
      description: 'Engaging interactive games and activities that bring people together. Perfect for team building and group entertainment.',
      icon: 'ri-team-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-1.png',
      link: '/interactive-activities'
    },
    {
      title: 'Entertainment Services',
      description: 'Professional entertainers including clowns, magicians, and character appearances to make your event truly special.',
      icon: 'ri-magic-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-3.png',
      link: '/entertainment'
    },
    {
      title: 'Party Games',
      description: 'Classic carnival games and modern party activities. From game wheels to skill challenges, we have it all.',
      icon: 'ri-gamepad-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png',
      link: '/services'
    },
    {
      title: 'Fun Foods Equipment',
      description: 'Cotton candy, popcorn, snow cone machines and more. Add delicious treats to your event with our food equipment rentals.',
      icon: 'ri-cake-3-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-1.png',
      link: '/services'
    },
    {
      title: 'Photo Programs',
      description: 'Create lasting memories with our photo booth services and custom photo keepsakes for your guests.',
      icon: 'ri-camera-fill',
      image: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-3.png',
      link: '/services'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
            Our Event Entertainment Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From bounce houses to entertainment, we provide everything you need for an unforgettable event in Allentown, Bethlehem, and Easton PA.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Link 
              key={index}
              to={service.link}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">
                  {service.description}
                </p>
                <div className="flex items-center text-red-600 font-semibold text-sm">
                  Learn More
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link 
            to="/services" 
            className="inline-block bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap"
          >
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
}